import React from 'react'
import BackgroundImage from 'assets/imgs/loginBackground.png'
import laserenisimaLogo from 'assets/imgs/laserenisimaLogo.png'
import danoneLogo from 'assets/imgs/danoneLogo.png'
import i18n from 'services/i18n'
import {
  Container,
  Wrapper,
  ImageWrapper,
  StyledImgDanone,
  StyledImgLaserenisima,
  StyledLabel,
  Redirect
} from './styled'

class NotFound extends React.Component {
  render() {
    return (
      <Container
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }}
      >
        <Wrapper>
          <ImageWrapper>
            <StyledImgDanone src={danoneLogo} />
            <StyledImgLaserenisima src={laserenisimaLogo} />
          </ImageWrapper>
          <StyledLabel size={250}>404</StyledLabel>
          <StyledLabel>UPS! {i18n('404').ROUTE_NOT_FOUND}</StyledLabel>
          <Redirect href={'/'}>{i18n('404').REDIRECT_MESSAGE}</Redirect>
        </Wrapper>
      </Container>
    )
  }
}

export default NotFound
